import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../common/rest.operators';
import { PayloadAction } from '../../store.model';
import { Mi2Service } from '../core';
import { getModuleInjector } from '../mi2.metadata';

import { ActionType } from './main.action';
import { Reload, reloadResult } from './state/reload.action';
import {
    ShowTrendDialog,
    showTrendDialogResult,
} from './state/show-trend-dialog.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const reload = (action: Observable<PayloadAction<ActionType, Reload>>) =>
    action.pipe(
        ofType(ActionType.MI2_MAIN__RELOAD),
        switchMap((act: PayloadAction<ActionType, Reload>) => {
            const service = getModuleInjector().get<Mi2Service>(Mi2Service);
            return service.retrieveDirectReports(act.payload.userId).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            data: ret,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(reloadResult({ ...act.payload }, act.storePath)),
                ),
            );
        }),
    );

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const showTrend = (
    action: Observable<PayloadAction<ActionType, ShowTrendDialog>>,
) =>
    action.pipe(
        ofType(ActionType.MI2_MAIN__SHOW_TREND_DIALOG),
        switchMap((act: PayloadAction<ActionType, ShowTrendDialog>) => {
            const service = getModuleInjector().get<Mi2Service>(Mi2Service);
            return service
                .retrieveDirectReportsHistory(
                    act.payload.managerId,
                    act.payload.userId,
                )
                .pipe(
                    map((ret) => {
                        return showTrendDialogResult(
                            {
                                ...act.payload,
                                data: ret,
                            },
                            act.storePath,
                        );
                    }),
                    catchErrorLogRet(
                        of(
                            showTrendDialogResult(
                                { ...act.payload },
                                act.storePath,
                            ),
                        ),
                    ),
                );
        }),
    );

export const mainEpics = [reload, showTrend];
